import React, { useMemo } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { getNavigationMenu } from '../config/navigation';
import { getUserType } from '../utils/authStorage';
import { useLayout } from './AppLayout';

function Sidebar() {
  const userType = getUserType();
  const location = useLocation();
  const navigate = useNavigate();
  const { sidebarCollapsed, setSidebarCollapsed, setMobileSidebarOpen, openFormModal } = useLayout();
  const menu = useMemo(() => getNavigationMenu(userType), [userType]);

  const handleChildClick = (child) => {
    setMobileSidebarOpen(false);
    if (child.action) {
      openFormModal(child.action);
      if (child.path) navigate(child.path);
      return;
    }
    navigate(child.path);
  };

  return (
    <aside className="hr-sidebar">
      <NavLink to="/dashboard" className="hr-sidebar-brand" onClick={() => setMobileSidebarOpen(false)}>
        <img
          src={sidebarCollapsed ? '/Images/icon.png' : '/Images/LOGO_ORNNOVA.avif'}
          alt="Ornnova"
          className={`hr-sidebar-logo ${sidebarCollapsed ? 'hr-sidebar-logo-compact' : ''}`}
        />
      </NavLink>

      <nav className="hr-sidebar-nav">
        {menu.map((item) => {
          const isActive = location.pathname === item.path || item.children?.some((c) => c.path === location.pathname);
          return (
            <div key={item.id} className="hr-sidebar-group">
              <NavLink
                to={item.path}
                className={`hr-sidebar-link ${isActive ? 'active' : ''}`}
                onClick={() => setMobileSidebarOpen(false)}
              >
                <span className="hr-sidebar-icon">{item.icon}</span>
                {!sidebarCollapsed && <span>{item.label}</span>}
              </NavLink>
              {!sidebarCollapsed && item.children?.length > 0 && (
                <div className="hr-sidebar-children">
                  {item.children.map((child) => (
                    <button
                      key={`${item.id}-${child.label}`}
                      type="button"
                      className={`hr-sidebar-child ${location.pathname === child.path ? 'active' : ''}`}
                      onClick={() => handleChildClick(child)}
                    >
                      {child.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </nav>

      <button
        type="button"
        className="hr-sidebar-toggle"
        onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
        aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        {sidebarCollapsed ? '»' : '«'}
      </button>
    </aside>
  );
}

export default Sidebar;
